
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-671cc93f&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CustomerDetails.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CustomerDetails.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-671cc93f!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CustomerDetails.vue"),
  /* scopeId */
  "data-v-671cc93f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Loan/CustomerDetails.vue
// module id = 700
// module chunks = 0